import { TextCaption, Tooltip } from '@carboncopyco/ui';
import * as Accordion from '@radix-ui/react-accordion';
import classNames from 'classnames';
import type React from 'react';
import { useRef } from 'react';
import { parseNodeId } from './utils';

type TreeNodeProps = {
  id: string;
  header: React.ReactNode;
  content?: React.ReactNode;
  isSelected: boolean;
  onSelect: (id: string) => void;
  disabled?: boolean;
  isOrigin: boolean;
  tooltipText?: string;
};

export const indents = ['pl-2', 'pl-12', 'pl-24', 'pl-36', 'pl-58', 'pl-52'];

export const TreeNode = <N,>({
  id,
  header,
  content,
  isSelected,
  onSelect,
  disabled,
  isOrigin,
  tooltipText,
}: TreeNodeProps) => {
  const level = parseNodeId<N>(id)[2];
  const nodeRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <Accordion.Item
        asChild
        value={id}
        ref={nodeRef}
      >
        <div ref={nodeRef}>
          <div
            className={classNames(
              'py-2 pr-2 rounded-md cursor-pointer',
              indents[level],
              isSelected ? 'bg-ds-primary-50' : 'hover:bg-ds-natural-50',
              {
                'bg-ds-accent3-100 opacity-40 pointer-events-none text-selection-none':
                  disabled,
              },
              isOrigin && 'origin-tree-node'
            )}
            onClick={() => onSelect(id)}
          >
            <Accordion.Header>{header}</Accordion.Header>
          </div>
          <Accordion.Content>{content}</Accordion.Content>
        </div>
      </Accordion.Item>
      {disabled && tooltipText && !isOrigin && (
        <Tooltip
          anchorRef={nodeRef}
          placement="top-start"
          noArrow
          interactive={false}
        >
          <div className="py-1.5 px-2.5 max-w-[250px]">
            <TextCaption label={tooltipText} />
          </div>
        </Tooltip>
      )}
    </>
  );
};
